import Legend from './Legend';
import LegendTitle from './LegendTitle';
var ChartLegend = Legend;
ChartLegend.Title = LegendTitle;
export default ChartLegend;